import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatErr } from "@/lib/api";
import { toast } from "sonner";
import { Flame } from "lucide-react";
import { Field } from "./Login";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name:"", email:"", mobile:"", password:"", confirm_password:"" });
  const [loading, setLoading] = useState(false);
  const set = (k) => (v) => setForm(f => ({ ...f, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    if (form.password !== form.confirm_password) return toast.error("Passwords do not match");
    setLoading(true);
    try {
      await register(form);
      toast.success("Welcome to Stylefire!");
      nav("/");
    } catch (e) { toast.error(formatErr(e?.response?.data?.detail) || "Registration failed"); }
    finally { setLoading(false); }
  };

  const googleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <main className="min-h-[80vh] grid lg:grid-cols-2">
      <div className="flex items-center justify-center p-8">
        <div className="w-full max-w-md">
          <h1 className="font-display text-3xl font-bold">Create your account</h1>
          <p className="text-slate-500 text-sm mt-1">Join Stylefire — Style that ignites.</p>
          <form onSubmit={submit} className="mt-8 space-y-4">
            <Field label="Full Name" value={form.name} onChange={set("name")} testid="reg-name"/>
            <Field label="Mobile Number" value={form.mobile} onChange={set("mobile")} testid="reg-mobile"/>
            <Field label="Email Address" type="email" value={form.email} onChange={set("email")} testid="reg-email"/>
            <Field label="Password" type="password" value={form.password} onChange={set("password")} testid="reg-password"/>
            <Field label="Confirm Password" type="password" value={form.confirm_password} onChange={set("confirm_password")} testid="reg-confirm"/>
            <button data-testid="reg-submit" disabled={loading} className="btn-primary-sf w-full py-3 rounded-full font-semibold disabled:opacity-60">{loading?"Creating…":"Create account"}</button>
          </form>
          <div className="my-5 flex items-center gap-3"><div className="h-px bg-slate-200 flex-1"/><span className="text-xs text-slate-400">OR</span><div className="h-px bg-slate-200 flex-1"/></div>
          <button data-testid="reg-google" onClick={googleLogin} className="w-full border border-slate-200 rounded-full py-3 font-semibold flex items-center justify-center gap-2 hover:bg-slate-50">
            <img src="https://www.google.com/favicon.ico" alt="" className="w-4 h-4"/> Continue with Google
          </button>
          <p className="text-sm text-slate-600 mt-6 text-center">Already have an account? <Link to="/login" data-testid="reg-login-link" className="text-[#004BCA] font-semibold">Sign in</Link></p>
        </div>
      </div>
      <div className="hidden lg:block relative">
        <img src="https://images.unsplash.com/photo-1664076458686-3449062080ac?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHw0fHx3b21lbiUyMGZhc2hpb24lMjBlZGl0b3JpYWwlMjBtb2RlbHxlbnwwfHx8fDE3ODE5NTY4MTd8MA&ixlib=rb-4.1.0&q=85" className="absolute inset-0 w-full h-full object-cover" alt=""/>
        <div className="absolute inset-0 hero-overlay"/>
        <div className="absolute bottom-10 left-10 text-white max-w-md">
          <div className="flex items-center gap-2 mb-3"><Flame/><span className="font-display font-bold text-2xl">Stylefire</span></div>
          <h2 className="font-display text-3xl font-bold">Editorial fashion. Every day.</h2>
        </div>
      </div>
    </main>
  );
}
